import { Permission } from "./permission";
import { useAuth } from "./use-auth";

export function usePermissionCheck(...permissions: Permission[]): boolean;
export function usePermissionCheck(permissions: Permission | Permission[]): boolean;
export function usePermissionCheck(args: any): boolean {
  const permissions = args && Array.isArray(args) ? (args as Permission[]) : [args as Permission];
  const { currentUser } = useAuth();
  return currentUser?.hasAnyOf(permissions) || false;
}
